const CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID;
const AUTHORITY = process.env.REACT_APP_AUTH_AUTHORITY;
const REDIRECT_URI = process.env.REACT_APP_AUTH_REDIRECT_URI;
const SCOPES_URL = process.env.REACT_APP_AUTH_SCOPES_URL;
const API_URL = process.env.REACT_APP_SERVER_URL;

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: AUTHORITY, // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    redirectUri: REDIRECT_URI,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: [],
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  graphMe: {
    endpoint: "https://graph.microsoft.com/v1.0/me",
    scopes: ["User.Read"],
  },
  addEmployment: {
    endpoint: `${API_URL}/employment/add`,
    scopes: [SCOPES_URL], // e.g. api://xxxxxx/access_as_user
  },
  updateEmployment: {
    endpoint: `${API_URL}/employment/update`,
    scopes: [SCOPES_URL], // e.g. api://xxxxxx/access_as_user
  },
  validatedSteps: {
    endpoint: `${API_URL}/validatedsteps`,
    scopes: [SCOPES_URL], // e.g. api://xxxxxx/access_as_user
  },
  updateValidatedSteps: {
    endpoint: `${API_URL}/validatedsteps/update`,
    scopes: [SCOPES_URL], // e.g. api://xxxxxx/access_as_user
  },
  getOrganization: {
    endpoint: `${API_URL}/organization/`,
    scopes: [SCOPES_URL], // e.g. api://xxxxxx/access_as_user
  },
  getEmployment: {
    endpoint: `${API_URL}/employment`,
    scopes: [SCOPES_URL], // e.g. api://xxxxxx/access_as_user
  },
  archiveEmployment: {
    endpoint: `${API_URL}/employment/archive`,
    scopes: [SCOPES_URL], // e.g. api://xxxxxx/access_as_user
  },
  apiVersion: {
    endpoint: `${API_URL}/version`,
    scopes: [SCOPES_URL], // e.g. api://xxxxxx/access_as_user
  },
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
